import { EMPTY_DEPARTMENT_NAME } from 'rlink-greenhouse/constants';

export default function spliceJobPostings (jobPostings, size = 3) {
  let splicedPostings = [];
  let departmentNames = Object.keys(jobPostings);

  departmentNames.sort((a, b) => {
    if (a.toUpperCase() === EMPTY_DEPARTMENT_NAME.toUpperCase()) {
      return -1;
    } else if (b.toUpperCase() === EMPTY_DEPARTMENT_NAME.toUpperCase()) {
      return 1;
    } else {
      if (a.toUpperCase() < b.toUpperCase()) {
        return -1;
      } else if (a.toUpperCase() > b.toUpperCase()) {
        return 1;
      } else {
        return 0;
      }
    }
  });

  while (departmentNames.length > 0) {
    let departmentGroup = departmentNames.splice(0, size);
    let postingGroup = {};
    departmentGroup.forEach(department => {
      postingGroup[department] = jobPostings[department];
    });
    splicedPostings.push(postingGroup);
  }

  return splicedPostings;
}



// WEBPACK FOOTER //
// ./lib/rlink-greenhouse/spliceJobPostings.js